import _ from 'lodash';

/**
 * Build `<Dropdown>` options from a list of company phone numbers, and surface a tooltip
 * showing the descriptive label for the currently-selected number (the dropdown itself
 * only shows the number, so the label otherwise wouldn't be visible after selection).
 */
export function getFormattedPhoneNumbersWithTooltip(fromNumbers, fromNumber) {
  let tooltipMessage = '';
  const fromOptions = _.map(fromNumbers, from => {
    const label = from.label ? `${from.label} (${from.number})` : from.number;
    if (from.number === fromNumber && label !== from.number) {
      tooltipMessage = label;
    }
    return { value: from.number, label };
  });
  return { fromOptions, tooltipMessage };
}
